import React, { ReactElement } from "react";
import styled from "styled-components";
import SearchPageNavigation, {
  PageNavigationProps,
} from "./SearchPageNavigation";

export type PageNavigation = {
  resTotal: number;
  skip: number;
  limit: number;
  pageNavigationHandle: Function;
};

export type SearchResultListProps<T> = {
  renderSingle: Function;
  results: T[];
  pageNavigation?: PageNavigation;
};

function SearchResultList<T>({
  renderSingle,
  results,
  pageNavigation,
}: SearchResultListProps<T>) {
  return (
    <>
      {pageNavigation && <SearchPageNavigation {...pageNavigation} />}
      {results.length > 0 && (
        <div>
          {results.map((result: T) => {
            // return null;
            return renderSingle(result);
          })}
        </div>
      )}
    </>
  );
}

// const SearchResultList = <T,>({
//   renderSingle,
//   searchResults,
// }: SearchResultListProps<T>) => {
//   return <div>SearchResultList</div>;
// };

const DivNav = styled.div`
  margin-top: 1rem;
`;

export default SearchResultList;
